import { PlateEditor } from '@udecode/plate';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { BaseEditor, Editor } from 'slate';
import { ReactEditor } from 'slate-react';

export const useScrollToBlock = (editor: PlateEditor) => {
  const router = useRouter();
  const blockId = router.query.blockId;
  useEffect(() => {
    if (editor?.children?.length && blockId) {
      setTimeout(() => {
        const value = Editor.nodes<BaseEditor>(editor, {
          at: [],
          match: (n) => {
            return n['id'] === blockId;
          },
          mode: 'highest',
        });
        const path = value.next().value?.[1];
        if (path) {
          const range = Editor.range(editor, path);

          const editorWrapper = window.document.getElementById('file-wrapper');
          if (range) {
            const rect = ReactEditor.toDOMRange(editor, range).getBoundingClientRect();
            editorWrapper?.scrollTo({
              top: rect.top + editorWrapper?.scrollTop - 200,
              left: rect.left,
              behavior: 'smooth',
            });
          }
        }
        router.push(
          `${router.asPath.split('?')[0]}?${Object.keys(router.query)
            .map((key) =>
              !['commentId', 'slug', 'blockId'].includes(key) ? `${key}=${router.query[key]}` : ''
            )
            .filter((obj) => obj !== '')
            .join('&')}`
        );
      }, 700);
    }
  }, [editor?.children, blockId, router]);
};
